import { useState, useRef } from 'react'
import useOnClickOutside from 'use-onclickoutside'
import { CellWrapper, CellValue, ColName, CellOptionsWrapper, CellButton, CellIcon, CellDropDown, CellDropDownItems, CellDropDownItem } from '../styledEdit'

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

const Col = ({ colIdx, col, setSettingsDraft, addCol, removeCol }) => {
  const [hovered, setHovered] = useState(false)
  const [dropDownOpen, setDropDownOpen] = useState(false)

  const ref = useRef()

  useOnClickOutside(ref, () => setDropDownOpen(false))

  const { title, hidden } = col

  return (
    <CellWrapper onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <CellValue isHidden={hidden}>
        <ColName>{alphabet[colIdx]}</ColName>
        <span>{title}</span>
      </CellValue>
      <CellOptionsWrapper ref={ref}>
        {
          (hovered || dropDownOpen) && (
            <CellButton onClick={() => setDropDownOpen(!dropDownOpen)}>
              <CellIcon className="fas fa-chevron-down" />
            </CellButton>
          )
        }
        {
          dropDownOpen && (
            <CellDropDown>
              <CellDropDownItems>
                <CellDropDownItem onClick={() => { setSettingsDraft({ type: 'col', data: col, colIdx }); setHovered(false); setDropDownOpen(false) }}>
                  <span>Settings</span>
                  <em className="far fa-cog" style={{ marginLeft: '8px' }} />
                </CellDropDownItem>
                <CellDropDownItem onClick={() => { addCol(colIdx); setHovered(false); setDropDownOpen(false) }}>
                  <span>Prepend column</span>
                  <em className="far fa-arrow-alt-to-left" style={{ marginLeft: '8px' }} />
                </CellDropDownItem>
                <CellDropDownItem onClick={() => { addCol(colIdx + 1); setHovered(false); setDropDownOpen(false) }}>
                  <span>Append column</span>
                  <em className="far fa-arrow-alt-to-right" style={{ marginLeft: '8px' }} />
                </CellDropDownItem>
                <CellDropDownItem onClick={() => { removeCol(colIdx); setHovered(false); setDropDownOpen(false) }}>
                  <span>Remove column</span>
                  <em className="far fa-trash-alt" style={{ marginLeft: '8px' }} />
                </CellDropDownItem>
              </CellDropDownItems>
            </CellDropDown>
          )
        }
      </CellOptionsWrapper>
    </CellWrapper>
  )
}

export default Col